import { CartArrowRightIcon } from './CartArrowRightIcon';

/**
 * author: Michael Richins
 * id 31173BE4-3D5E-45EB-BD45-3D19E86AF6B2
 * name cart-arrow-right
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cart-arrow-right.svg
 * tags
 * - Shopping 
 */
export const ShoppingCartArrowRightIcon = CartArrowRightIcon;
export default ShoppingCartArrowRightIcon